// extracted by mini-css-extract-plugin
export default {"progressBar":"ProgressBar_progressBar__G5XXh","hrSegment":"ProgressBar_hrSegment__UpfdF","known":"ProgressBar_known__5eoNz","remain":"ProgressBar_remain__uhQeD"};